import rightNavModule from './rightNav.module'
import rightPanelContainerModule from './rightPanelContainer.module'

export default {
  rightNav: rightNavModule,
  rightPanelContainer: rightPanelContainerModule,
}
